import { useSelector } from 'react-redux'
import { useCallback, useEffect, useState } from 'react'
import DialogStudentSelector from './Dialog'
import CustomAvatar from '../../../../../../avatar/Avatar'
import TextEllipsis from '../../../../../../text/TextEllipsis'
import useAnalyticsCurriculum from '../../../../../../../hooks/analytics/useAnalyticsCurriculum'

const SelectorStudentClass = ({ onChange, type, selected, selectorState, disabled, view = 'current' }) => {
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const { getAnalyticsCurriculumByStudent, getAnalyticsCurriculumByClasses } = useAnalyticsCurriculum()
  const history = useSelector((state) => state?.analytics?.analyticsCurriculum?.history || null)
  const filter = null
  const onLoad = useCallback(
    async (selectorState, selected, filter, history) => {
      if (!selected) return
      if (selectorState === 'filter-by-student') {
        await getAnalyticsCurriculumByStudent(selected._id, filter, view, history?._id)
      }
      if (selectorState === 'filter-by-classes') {
        await getAnalyticsCurriculumByClasses(selected._id, filter, view, history?._id)
      }
    },
    [selectorState, selected, view]
  )
  useEffect(() => {
    onLoad(selectorState, selected, filter, history)
  }, [selectorState, selected, filter, history, onLoad])

  const [dialog, setDialog] = useState(false)
  return (
    <>
      <div
        className={`min-w-150px max-w-150px flex gap-2 items-center px-2 h-16 ${disabled || roles.some((role) => ['Student'].includes(role)) ? '' : 'bg-clickeabled  cursor-pointer'} ${disabled ? ' cursor-not-allowed opacity-50' : ''}`}
        size='small'
        style={{ padding: '0 0.5rem ' }}
        onClick={() =>
          roles.some((role) => ['Student'].includes(role)) || disabled ? undefined : setDialog(true)
        }
      >
        {type === 'analyticsUsers' && (
          <CustomAvatar
            size='small'
            variant={'rounded'}
            alt={selected?.code}
            src={selected ? `photos/${selected?.photo}` : null}
          />
        )}
        {selected ? (
          <div className=' overflow-hidden'>
            <TextEllipsis className='font-bold text-primary'>{selected?.code}</TextEllipsis>
            <TextEllipsis className='text-sm'>{selected?.fullName || selected?.name}</TextEllipsis>
          </div>
        ) : (
          <span className='text-sm'>Select a {type === 'analyticsUsers' ? 'student' : 'class'}</span>
        )}
      </div>
      {dialog && (
        <DialogStudentSelector
          open={dialog}
          type={type}
          onClose={() => setDialog(false)}
          dataId={selected?._id}
          onApply={(value) => onChange(value)}
          view={view}
        />
      )}
    </>
  )
}

export default SelectorStudentClass
